import { Facebook, Instagram } from "@mui/icons-material";
import { Box, Container, Grid, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        backgroundColor: "#222",
        color: "#fff",
        paddingTop: 4,
        paddingBottom: 2,
      }}
    >
      <Container>
        <Grid container spacing={3}>
          {/* Left Section */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              {t("common:footer.about")}
            </Typography>
            <Typography variant="body2" paragraph>
              {t("common:footer.shortDescription")}
            </Typography>
          </Grid>

          {/* Center Section */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              {t("common:footer.contactUs")}
            </Typography>
            acrobeachfestival@gmail.com
          </Grid>

          {/* Right Section - Social Media Icons */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              {t("common:footer:followUs")}
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <IconButton
                color="inherit"
                href="https://www.facebook.com/AcroYogaBask"
                target="_blank"
              >
                <Facebook />
              </IconButton>
              <IconButton
                color="inherit"
                href="https://www.instagram.com/acrobeachfestival/"
                target="_blank"
              >
                <Instagram />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright Section */}
        <Box sx={{ textAlign: "center", marginTop: 4 }}>
          <Typography variant="body2" color="text.secondary">
            &copy; {new Date().getFullYear()} Acro Yoga Bask. All rights
            reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
